import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCabinetFiling } from "@awesome.me/kit-269fbef2e2/icons/duotone/solid";
/**
 * Creates a FontAwesomeIcon component with the given icon
 * @param icon The icon definition
 * @returns A function that returns a FontAwesomeIcon component
 */
export const createIconComponent = (icon: any): React.ComponentType<any> | React.ReactNode => {
    // Use a memoized component to ensure stability across renders
    return React.memo(function IconComponent(props: any) {
      if (!icon) {
        console.error('Undefined icon passed to createIconComponent');
        // Use a default icon as fallback
        return <FontAwesomeIcon icon={faCabinetFiling} {...props} />;
      }
      return <FontAwesomeIcon icon={icon} {...props} />;
    });
  };
  